import script from "./ModalValorNumerico.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalValorNumerico.vue?vue&type=script&setup=true&lang=js"

import "./ModalValorNumerico.vue?vue&type=style&index=0&id=44ae2086&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ae2086"]])

export default __exports__